import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-lg font-bold leading-tight" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-wrap gap-1"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Unknown", -1)
const _hoisted_5 = {
  key: 1,
  class: "mt-0 col-span-2"
}
const _hoisted_6 = {
  key: 2,
  class: "mt-0 col-span-2"
}
const _hoisted_7 = { class: "flex gap-1 items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Segments", -1)
const _hoisted_9 = { class: "grid grid-cols-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Box = _resolveComponent("Box")!
  const _component_Help = _resolveComponent("Help")!
  const _component_Field = _resolveComponent("Field")!
  const _component_FieldList = _resolveComponent("FieldList")!
  const _component_Segment = _resolveComponent("Segment")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Box, {
    as: _ctx.as,
    tabindex: "0",
    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleHighlightSection(_ctx.street))),
    onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleHighlightSection(_ctx.street))),
    class: "flex flex-col gap-3 p-2 border border-current shadow-md rounded-lg hover:bg-blue-100 focus:outline-none focus:ring-4 focus:ring-blue-300"
  }, {
    default: _withCtx(() => [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.street.name?.trim() || 'Unnamed segment'), 1),
      (_ctx.keys(_ctx.street)?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keys(_ctx.street), (classification, index) => {
              return (_openBlock(), _createBlock(_component_Box, {
                key: index,
                as: "span",
                color: "gray",
                variant: "light",
                class: "inline-flex px-2 py-0.5 text-xs uppercase border border-current rounded-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.label(_ctx.street.classifications[classification], classification)), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.street.minWidth || _ctx.street.maxWidth)
        ? (_openBlock(), _createBlock(_component_FieldList, {
            key: 1,
            class: "gap-1 text-sm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Field, {
                display: "inline",
                name: "Roadway width"
              }, {
                default: _withCtx(() => [
                  (!_ctx.street.minWidth && !_ctx.street.maxWidth)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_Help, { help: "We may display unknown values because the City of Portland\n                    does not manage this specific street section." }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        })
                      ]))
                    : (_ctx.street.minWidth != _ctx.street.maxWidth)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.street.minWidth) + " to " + _toDisplayString(_ctx.street.maxWidth) + " feet ", 1))
                      : (_ctx.street.minWidth == _ctx.street.maxWidth)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.street.minWidth) + " feet ", 1))
                        : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.street.segments && _ctx.street.segments.length)
        ? (_openBlock(), _createBlock(_component_Panel, {
            key: 2,
            color: "gray",
            variant: "light",
            class: "text-sm",
            open: _ctx.showSegments,
            onToggle: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSegments = !_ctx.showSegments))
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_Box, {
                  color: "blue",
                  class: "px-1 text-xs rounded-lg"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.street.segments.length), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.street.segments, (segment, index) => {
                  return (_openBlock(), _createBlock(_component_Segment, {
                    as: "li",
                    tabindex: "0",
                    key: segment.id,
                    street: segment,
                    onHighlight: _ctx.handleHighlightSegment,
                    class: _normalizeClass({
            'border-t': index > 0,
            'rounded-b-md': index == _ctx.street.segments.length - 1,
          })
                  }, null, 8, ["street", "onHighlight", "class"]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["open"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["as"]))
}